import { isTrustedHostname } from './cookie';

// 当前地址已带 returnUrl 时直接透传其值，避免把登录页 URL 再包一层产生嵌套；
// 未带（或为空）时原样返回 href，由调用方按原逻辑包装
export function resolveReturnUrl(href: string) {
  const url = new URL(href);
  return url.searchParams.get('returnUrl') || href;
}

export default function safeReturnUrl(
  value: string | null | undefined,
  origin = window.location.origin,
) {
  if (!value) return null;
  try {
    const target = new URL(value, origin);
    if (
      !['http:', 'https:'].includes(target.protocol) ||
      target.username ||
      target.password ||
      (target.origin !== origin && !isTrustedHostname(target.hostname))
    ) {
      return null;
    }
    return target.origin === origin
      ? `${target.pathname}${target.search}${target.hash}`
      : target.href;
  } catch {
    return null;
  }
}
